var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',{staticClass:"monitor-card"},[_c('div',{staticClass:"header",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._t("filter")],2)]),_c('div',{staticClass:"content"},[_vm._t("content")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }